export const AllowIndexURIs = ["/subscribe", "/"];
